// extracted by mini-css-extract-plugin
export default {"Registration":"registration_Registration__wsVxL","Title":"registration_Title__L5Gcs"};